import { Box, Button, TextField, styled } from "@mui/material"
import NewBackground from "../../../assets/images/NewBackground.png"
export const AuthPageWrapper = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  height: "100vh",
  flexWrap: "wrap",
  // border: '1px solid red',
}))

export const AuthMainWrapper = styled(Box)(() => ({
  flex: 2,
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "center",
  height: "100%",

  // padding: '0 120px',
  //boxShadow: "0px 3px 4px #00000014",
}))

export const AuthMainHeader = styled(Box)(() => ({
  display: "flex",
  width: "58%",
  alignItems: "center",
  justifyContent: "center",
}))

export const LoginWrapper = styled(Box)(() => ({}))

export const LoginFormMain = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  alignItems: "center",
  justifyContent: "center",
}))

export const LoginButton = styled(Button)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  color: "white",
  marginTop: "20px",
  height: "50px",
  backgroundColor: "#3366D6",
  borderRadius: "10px",
  cursor: "pointer",
  width: "100%",
}))

export const AuthMainFooter = styled(Box)(() => ({
  padding: "0 5px",
  width: "60%",
  display: "flex",

  fontSize: "10px",
  marginTop: "15px",
}))

export const AuthBannerWrapper = styled(Box)(() => ({
  flex: 3,
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-evenly",
  // border: '1px solid yellow',
  height: "100%",
  backgroundColor: "#fff",
  backgroundImage: `url(${NewBackground})`,
  backgroundRepeat: "no-repeat",
}))

export const BannerLeft = styled(Box)(() => ({
  marginLeft: "90px",
}))

export const BannerRight = styled(Box)(() => ({
  // display: "flex",
  // flexDirection: "column"
  marginLeft: "auto",
  marginRight: "100px",
}))
